import React, { useState, useEffect, useRef } from 'react';
import Slider from "react-slick";

// HELPERS
import { withinDateRange, parseDateWithOffset } from "src/helpers/date";
import { PrevArrow, NextArrow, Dots, Dot } from 'src/helpers/slick';
// HOOKS
import { useQuery } from 'src/hooks/query';
// LAYOUT.
import Layout from 'src/modules/hero-unconstrained/layout';

// SCSS.
import 'src/modules/hero-unconstrained/index.scss';
import 'src/modules/hero-unconstrained/slick-styling.scss';
import "slick-carousel/slick/slick.scss";
import "slick-carousel/slick/slick-theme.scss";

const Start = ({ data, settings, placeholders }) => {
    const sliderRef = useRef(null);
    const [carouselItems, setCarouselItems] = useState(null);
    const query = useQuery();
    const simulateDate = query.get('simulate-date') ? parseDateWithOffset(query.get('simulate-date')) : null;

    const togglePlaying = (event) => {
        if (sliderRef.current) {
            if (!event.target.classList.contains('paused')) {
                event.target.classList.add('paused');
                sliderRef.current.slickPause();
            }
            else {
                event.target.classList.remove('paused');
                sliderRef.current.slickPlay();
            }
        }
    };

    useEffect(() => {
        data.carousel_items && setCarouselItems(() => data.carousel_items?.filter((slide) => {
            var startDate = slide?.start_date?.length > 0 ? parseDateWithOffset(slide.start_date) : null;
            var endDate = slide?.end_date?.length > 0 ? parseDateWithOffset(slide.end_date) : null;
            var isActive = withinDateRange(startDate, endDate, slide?.enable_holiday_settings, slide?.schedule_show_hide, simulateDate);

            if ((!slide?.schedule_show_hide && !slide?.enable_holiday_settings) || slide?.module_status === 'show' && isActive || slide?.module_status === 'hide' && !isActive) {
                return slide;
            }
        }))
    }, [data.carousel_items]);


    return (
        <Layout data={data} settings={settings}>
            <Layout.Container data={data} settings={settings}>
                <Layout.Container.Carousel data={data} settings={settings} carouselClass={carouselItems?.length === 1 ? ' only-one-slide' : ''}>
                    <Slider ref={sliderRef} class={`carousel`} {...sliderSettings(carouselItems, data, settings)}>
                        {carouselItems && carouselItems.map((slide, index) => <Layout.Container.Carousel.Slide data={data} placeholders={placeholders} slide={slide} key={index} />)}
                    </Slider>
                    {carouselItems && carouselItems.length > 1 && data.slide_transition == "fade" && (
                        <button type="button" class="pause" onClick={togglePlaying}>
                            Pause
                        </button>
                    )}
                </Layout.Container.Carousel>
                <Layout.Container.TextBelowCarousel data={data} settings={settings} placeholders={placeholders} />
            </Layout.Container>
        </Layout>
    );
};

export default Start;

const sliderSettings = (carouselItems, data, settings) => {
    let ss = {
        autoplay: (carouselItems?.length > 1),
        pauseOnHover: false,
        infinite: (carouselItems?.length > 1),
        slidesToShow: 1,
        slidesToScroll: 1,
        slide: 'div',
        speed: 800,
        adaptiveHeight: true,
        className: `${data.type} ${data.style}`
    };

    if (data.slide_transition == "fade") {
        ss.fade = true;
        ss.autoplaySpeed = 5000;
        ss.arrows = false;
    }
    else {
        ss.autoplaySpeed = 8000;
        ss.dots = (carouselItems?.length > 1);
        ss.customPaging = dot => <Dot dot={dot} data={data} settings={settings} />;
        ss.appendDots = dots => <Dots dots={dots} data={data} settings={settings} />;
        ss.arrows = true;
        ss.nextArrow = <NextArrow />;
        ss.prevArrow = <PrevArrow />;

        ss.responsive = [
            {
                breakpoint: 640,
                settings: {
                    dots: false
                    // dots: data.style !== 'text-on-carousel' ? false : true,
                }
            }
        ];
    }

    return ss;
};
